import { AlertCircle } from 'lucide-react';
import type { FC } from 'react';

interface ErrorMessageProps {
  message: string | null;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ message }) => {
  if (!message) return null;

  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-start gap-3">
      <AlertCircle className="text-red-500 flex-shrink-0" size={20} />
      <p className="text-sm text-red-700">{message}</p>
    </div>
  );
};
